import { CommonModule } from '@angular/common';
import { Component, NgModule, Input } from '@angular/core';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxListModule } from 'devextreme-angular/ui/list';
import { DxLoadPanelModule } from 'devextreme-angular/ui/load-panel';
import { TaskCardMenuComponent} from '../card-menu/task-card-menu.component';

@Component({
  selector: 'dk-card-activities',
  templateUrl: './card-activities.component.html',
  styleUrls: ['./card-activities.component.scss'],
  standalone: true,
  imports: [
    DxListModule,
    DxButtonModule,
    DxLoadPanelModule,
    CommonModule,
    TaskCardMenuComponent,
  ],
})
export class CardActivitiesComponent {
  @Input() activities: any[];

  @Input() showBy? = false;

  @Input() isLoading: boolean;

  activityMenuItems: Array<{ text: string }> = [
    { text: 'Detayını gör' },
    { text: 'Sil' },
  ];
}
